import {userConstants} from '../constants'

const initialState = {
  token: window.localStorage.getItem('token'),
  user: JSON.parse(window.localStorage.getItem('user')),
  isAccountLoaded: window.localStorage.getItem('user') !== null
}

export function AccountReducer (state = initialState, action) {
  switch (action.type) {
    case (userConstants.LOGIN_SUCCESS): {
      window.localStorage.setItem('token', action.token)
      const updatedState = Object.assign({}, state, {
        token: action.token
      })
      return updatedState
    }
    case (userConstants.REGISTER_SUCCESS): {
      window.localStorage.setItem('token', action.token)
      const updatedState = Object.assign({}, state, {
        token: action.token
      })
      return updatedState
    }
    case (userConstants.GET_USER_DETAILS_SUCCESS): {
      window.localStorage.setItem('user', JSON.stringify(action.user))
      const updatedState = Object.assign({}, state, {
        user: action.user,
        isAccountLoaded: true
      })
      return updatedState
    }
    case (userConstants.LOGOUT): {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('account')
      window.location.reload()
      const updatedState = Object.assign({}, state, {
        token: undefined
      })
      return updatedState
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AccountReducer.js